import React from "react";
import { Button, Dropdown } from "antd";
import { MoreOutlined, EditFilled } from "@ant-design/icons";
import { useNavigate } from "react-router";

import DeleteCustomField from "./DeleteCustomField";
import { useLeadFormActions } from "./hooks/useLeadFormActions";
import Clone from "./Clone";
import Share from "./Share";
import { configType } from "../../constant/WebToLead";

const ActionMenu = ({ row, page, setPage, isExpired, onSubscription }) => {
  const navigate = useNavigate();
  const { handleDelete, leadForms } = useLeadFormActions();

  const items = [
    {
      key: "1",
      label: (
        <div
          className="heading14px d-flex align-items-center"
          style={{ gap: 10, color: "#29292B", paddingRight: 30 }}
          onClick={() => {
            if (isExpired) {
              onSubscription();
            } else {
              navigate(`/settings/web-to-lead/${row.id}`);
            }
          }}
        >
          <EditFilled />
          Edit
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <Clone
          formData={row}
          setPage={setPage}
          isExpired={isExpired}
          onSubscription={onSubscription}
        />
      ),
    },
    row?.configType !== configType.SHARED_URL && {
      key: "3",
      label: <Share formData={row} />,
    },
    {
      key: "4",
      label: (
        <DeleteCustomField
          isFormDelete
          fieldName={row?.formName}
          isExpired={isExpired}
          onSubscription={onSubscription}
          onDelete={() => {
            handleDelete(row, leadForms?.content?.length === 1 ? 1 : page);
          }}
        />
      ),
    },
  ].filter(Boolean);

  return (
    <Dropdown menu={{ items }} trigger={["click"]}>
      <Button type="text" icon={<MoreOutlined />} />
    </Dropdown>
  );
};

export default ActionMenu;
